import { render, staticRenderFns } from "./SysConfig.vue?vue&type=template&id=50826534"
import script from "./SysConfig.vue?vue&type=script&lang=js"
export * from "./SysConfig.vue?vue&type=script&lang=js"
import style0 from "./SysConfig.vue?vue&type=style&index=0&id=50826534&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50826534')) {
      api.createRecord('50826534', component.options)
    } else {
      api.reload('50826534', component.options)
    }
    module.hot.accept("./SysConfig.vue?vue&type=template&id=50826534", function () {
      api.rerender('50826534', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/config/SysConfig.vue"
export default component.exports